var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.update)?_c('Masonry',{attrs:{"title":"解决方案","category_path":"solution","category_id":_vm.categoryID}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }